export default __webpack_public_path__ + "static/media/buffer1.619f889c.jpg";